<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    prevLink = '',
    prevLinkText,
    nextLink = '',
    nextLinkText,
    pageNumberLabelTemplate,
    fullPager = false,
    rel = undefined,
    dataTestId = 'pagination-control',
  } = $props();
</script>

<div class="w-full flex print:hidden items-center justify-between" data-testid={dataTestId}>
  {#if prevLink}
    <BaseLink
      className="flex items-center text-blue-cerulean group hover-hover:hover:text-blue-darkish active:text-blue-darkish"
      url={prevLink}
      {rel}
      dataTestId="{dataTestId}-prev-link"
    >
      <svg class="mr-2 inline-block fill-current w-4 h-4 lg:w-5 lg:h-5 rotate-180">
        <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
      </svg>
      <span
        class="text-base lg:text-xl leading-normal font-medium hover-hover:group-hover:underline group-active:underline"
        class:sr-only={!fullPager}
        class:min-w-18={fullPager}
      >
        {prevLinkText}
      </span>
    </BaseLink>
  {:else}
    <div class="opacity-25" class:min-w-25={fullPager}>
      <svg class="mr-2 inline-block fill-current w-4 h-4 lg:w-5 lg:h-5 rotate-180">
        <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
      </svg>
    </div>
  {/if}
  {#if pageNumberLabelTemplate}
    <div class:hidden={fullPager} class:sm:block={fullPager} class:lg:text-lg={fullPager}>
      {pageNumberLabelTemplate}
    </div>
  {/if}
  {#if nextLink}
    <BaseLink
      className="flex justify-end items-center text-blue-cerulean group hover-hover:hover:text-blue-darkish active:text-blue-darkish"
      url={nextLink}
      {rel}
      dataTestId="{dataTestId}-next-link"
    >
      <span
        class="text-base lg:text-xl leading-normal text-right font-medium hover-hover:group-hover:underline group-active:underline"
        class:sr-only={!fullPager}
        class:min-w-18={fullPager}
      >
        {nextLinkText}
      </span>
      <svg class="ml-2 inline-block fill-current w-4 h-4 lg:w-5 lg:h-5">
        <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
      </svg>
    </BaseLink>
  {:else}
    <div class="opacity-25 text-right" class:min-w-25={fullPager}>
      <svg class="ml-2 inline-block fill-current w-4 h-4 lg:w-5 lg:h-5">
        <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
      </svg>
    </div>
  {/if}
</div>
